import { c as _c } from "react/compiler-runtime";
export default function GroupCreateNumericValue(t0) {
  const $ = _c(14);
  const {
    value,
    minValue,
    maxValue,
    label,
    labelId,
    setValue
  } = t0;
  let t1;
  if ($[0] !== setValue) {
    t1 = e => {
      const newValue = e.target.value;
      if (newValue === "") {
        setValue(null);
      } else {
        setValue(parseInt(newValue));
      }
    };
    $[0] = setValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onChange = t1;
  const t2 = value ?? "";
  let t3;
  if ($[2] !== labelId || $[3] !== maxValue || $[4] !== minValue || $[5] !== onChange || $[6] !== t2) {
    t3 = <input type="number" min={minValue} max={maxValue} value={t2} onChange={onChange} id={labelId} autoComplete="off" className={"tw-form-input tw-block tw-px-4 tw-pb-3 tw-pt-3 tw-w-full tw-text-md tw-rounded-lg tw-border-0 tw-appearance-none tw-text-white tw-border-iron-700 focus:tw-border-blue-500 tw-peer\n     tw-py-3 tw-pl-4 tw-pr-4 tw-bg-iron-900 focus:tw-bg-iron-900 tw-font-medium tw-caret-primary-300 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 hover:tw-ring-iron-650 placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out"} placeholder=" " />;
    $[2] = labelId;
    $[3] = maxValue;
    $[4] = minValue;
    $[5] = onChange;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== label || $[9] !== labelId) {
    t4 = <label htmlFor={labelId} className={"tw-absolute tw-rounded-lg tw-cursor-text tw-text-md tw-font-medium tw-text-iron-500 tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-z-[1] tw-origin-[0] tw-bg-iron-900 peer-focus:tw-bg-iron-900 tw-px-2 peer-focus:tw-px-2 peer-focus:tw-text-primary-400 peer-placeholder-shown:tw-scale-100 \n  peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1"}>{label}</label>;
    $[8] = label;
    $[9] = labelId;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className="tw-group tw-w-full tw-relative">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}